import { ProductRepository } from '../repositories/ProductRepository';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { ViewController } from 'elc-service';
import { Product } from '../domain/entities/Product';
import { ItemTypes } from '../../api/ProdcatApiSdk';
import { observable, computed, action } from 'mobx';
import { Sku } from '../domain/entities/Sku';

export interface IProductBasicInfoViewControllerData {
    selectedSku?: Sku;
}

export class ProductBasicInfoViewController extends ViewController {
    private productRepository: ProductRepository;

    @observable public product: Product;
    @observable public selectedSku: Sku;
    @observable public selectedSkuId: string;

    constructor() {
        super();
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    @computed
    public get data(): IProductBasicInfoViewControllerData {
        return {
            selectedSku: this.selectedSku
        };
    }

    @action
    public loaded = async (skuId: string) => {
        this.selectedSkuId = skuId;
        const item = [
            {
                type: ItemTypes.sku,
                params: { id: skuId }
            }
        ];
        if (this.productRepository.products.length > 0) {
            this.product = this.productRepository.getProductBySkuId(skuId);
            if (!this.product) {
                await this.productRepository.getProductsByIds(item);
                this.product = <Product>this.productRepository.getProductBySkuId(skuId);
            }
            this.setSelectedSku();
        }
    };

    @action
    private setSelectedSku() {
        this.selectedSku = this.product.skus.find(
            ({ skuId }: Sku) => skuId === this.selectedSkuId
        ) as Sku;
    }
}
